import { useReducer } from 'react'
import { swiperPaymentStateReducer } from './reducer'

export const useSwiperPaymentReducer = () => {
  return useReducer(swiperPaymentStateReducer, {
    status: 'processingTransaction',
  })
}
